export default "__VITE_ASSET__BpXiQBtI__"